import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(ElementUI)

// 配置axios
axios.defaults.baseURL = process.env.VUE_APP_API_BASE || '/'
axios.defaults.timeout = 0

// 请求拦截器
axios.interceptors.request.use(
	config => {
		const token = store.getters.userToken;
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

// 响应拦截器
axios.interceptors.response.use(
	response => {
		return response;
	},
	error => {
		if (error.response && error.response.status === 401) {
			// 未授权，清除用户信息并跳转到登录页
			store.dispatch('logout');
			router.push('/login');
			Vue.prototype.$message.error('登录已过期，请重新登录');
		}
		return Promise.reject(error);
	}
);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app') 